import { StorageKeys } from '@cinch/oxd-utils/storage/src'
import * as Storage from '@cinch/oxd-utils/storage/src'
import { FORM_ERROR } from 'final-form'
import React from 'react'

import Title from '@cinch/oxd-components/page-title/src'
import { WbacService } from '@cinch/oxd-utils/requests/src'

import SEO from '../../../../../apps/www/src/components/seo'
import Details from '../../components/journey/details.component'
import VehiclePanel from '../../components/vehicle-panel/vehicle-panel.component'
import { VehicleInformation, VehicleLabelValueListsItemItem } from '../../types'

import * as styles from './vehicle-questions.module.css'

const formatLabelValues = (items: VehicleLabelValueListsItemItem[]) =>
  items.filter((item) => !!item.sortOrder).sort((a, b) => a.sortOrder! - b.sortOrder!)

const VehicleQuestionsComponent: React.FC<any> = (props) => {
  const { location, navigate, i18n, path } = props
  if (!location.state || !location.state.vehicleInformation) {
    return <Title>VehicleQuestionsComponent - no vehicleInformation</Title>
  }

  const vehicleInformation: VehicleInformation = location.state.vehicleInformation
  const vehicleInformationLabels = formatLabelValues(vehicleInformation.vehicleLabelValueLists[0])
  const imageItem = vehicleInformation.vehicleLabelValueLists[0].find((item) => item.label === 'ImageUrl')
  const vrm = vehicleInformation.vehicleLabelValueLists[0].find((item) => item.label === 'Vrm')

  const getValuation = (formData: any): Promise<any> => {
    const requestData = {
      quoteId: vehicleInformation.quoteId,
      quoteGuid: vehicleInformation.quoteGuid,
      valuationParameterDictionary: formData,
      journeyName: 'AllAttributes',
      journeyVariant: null,
      damages: [],
      save: true,
    }

    return new Promise((resolve) => {
      const { token: storageToken } = Storage.get(StorageKeys.wbac)

      return WbacService.post('/valuations', requestData, { headers: { Authorization: `JWT ${storageToken}` } })
        .then(({ data }) => data)
        .then((valuation) => {
          const options = { state: { vehicleInformation, valuation } }

          navigate('/sell/valuation/view', options)
        })
        .catch((e) => resolve({ [FORM_ERROR]: e.message }))
    })
  }

  return (
    <>
      <SEO noIndex={true} />
      <div className={styles.layout}>
        <Details onSubmit={getValuation} journey={vehicleInformation.journey} i18n={i18n} path={path} />
        <div className={styles.vehicleContainer}>
          <VehiclePanel
            action={{ method: () => navigate(`/sell/manual-lookup/${vrm!.value}`), label: i18n.panelTitle }}
            title={vrm && vrm.value}
            imageItem={imageItem}
            labels={vehicleInformationLabels}
          />
        </div>
      </div>
    </>
  )
}

export default VehicleQuestionsComponent
